module.exports = __webpack_public_path__ + "fonts/fa-solid-900.bea989e8.woff";